import React from 'react';
import { Panel } from 'reactflow';
import Style from './PropertyPanel.module.css';

// onDelete removes the node's mapping edges; canDelete is false when it has none (or is a system root).
const NodePanel = ({ node, onClose, onDelete, canDelete, canEdit }) => {
  // Determine if the node is a source or target node
  const isSource = node.type?.includes('source') || node.id === 'customer';
  const fieldClass = isSource ? Style.inputSource : Style.inputTarget;
  const buttonClass = isSource ? Style.buttonSource : Style.buttonPurple;

  // Generate sample data based on node type
  const getSampleValue = () => {
    const type = node.id.toLowerCase();
    if (type.includes('price') || type.includes('unit')) {
      return isSource ? '$199.99' : '199.99';
    } else if (type.includes('no') || type.includes('sku')) {
      return isSource ? 'ITEM-12345' : 'sku_12345';
    } else if (type.includes('desc') || type.includes('name')) {
      return 'Premium Office Chair';
    } else if (type.includes('quan') || type.includes('stock')) {
      return '24';
    } else {
      return 'Sample Data';
    }
  };

  return (
    <Panel position="top-right" className={Style.panel}>
      <div className={Style.header}>
        <h3 className={Style.title}>Node Properties</h3>
        <button
          type="button"
          onClick={onClose}
          className={Style.close}
          aria-label="Close"
        >
          <i className="uil-times" aria-hidden="true" />
        </button>
      </div>
      <div className={Style.body}>
        <div>
          <label className={Style.label}>Field Name</label>
          <input
            value={node.data.label}
            className={`${Style.input} ${fieldClass} ${Style.inputStrong}`}
            readOnly
          />
        </div>
        <div>
          <label className={Style.label}>Type</label>
          <input
            value={isSource ? 'Source Field' : 'Target Field'}
            className={`${Style.input} ${Style.inputMuted}`}
            readOnly
          />
        </div>
        <div>
          <label className={Style.label}>Sample Value</label>
          <input
            value={getSampleValue()}
            className={`${Style.input} ${Style.inputMuted}`}
            readOnly
          />
        </div>
        <div>
          <label className={Style.label}>Data Type</label>
          <input
            value={node.id.toLowerCase().includes('price') ? 'Decimal' : node.id.toLowerCase().includes('date') ? 'Date' : 'String'}
            className={`${Style.input} ${Style.inputMuted}`}
            readOnly
          />
        </div>
        {canEdit && <div className={Style.actions}>
          <button type="button" className={`${Style.button} ${buttonClass}`}>
            <i className="uil-edit" aria-hidden="true" />
            Edit
          </button>
          <button
            type="button"
            className={`${Style.button} ${Style.buttonDanger}`}
            onClick={onDelete}
            disabled={!canDelete}
            title={canDelete ? 'Remove the mappings on this field (applied on Save)' : 'This field has no mappings to remove'}
          >
            <i className="uil-trash-alt" aria-hidden="true" />
            Delete
          </button>
        </div>}
      </div>
    </Panel>
  );
};

export default NodePanel;
